import { Injectable } from '@angular/core';
import { RestService } from '../_rest.service';

@Injectable({
  providedIn: 'root'
})
export class ForumOffreService extends RestService{

  init(){
    this.endpoint = 'offres';
    this.modelname = 'offre';
    }
}
